/** Returns whether `process.env.NODE_ENV` exists and equals `env`. */
export function isNodeEnv(env: string) {
  // typeof guard, not just optional chaining: with the webpack ProcessPlugin
  // shim gone (P6), a bare `process` reference in the browser is an undeclared
  // identifier and throws ReferenceError — `process?.` does not survive that.
  return typeof process !== 'undefined' && process?.env?.NODE_ENV === env;
}
